// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2RtNi","text":"SelectPayment_text__28wpl","title":"SelectPayment_title__3L45h","btn":"SelectPayment_btn__2eFZo"};